import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '../../utils/stylesheet/colors';
import './styles.scss';

const SectionWrapper = styled.div`
  display: block;
  background-color: ${colors.dark_blue};
  border-radius: 1rem;
  ${({ disablePadding }) => (disablePadding ? 'padding: 0;' : 'padding: 3rem;')}
  overflow: auto;
  @media only screen and (max-width: 560px) {
    padding: 1rem;
    border-radius: 8px;
    width: unset !important;
    ${({ disableMargin }) => (disableMargin ? 'margin-bottom: 0' : 'margin: 1rem 1rem 6rem;')}
  }
  ${({ disableMargin }) => (disableMargin ? 'margin: 0' : 'margin: auto;')}
  ${({ size }) => (size === 'small' ? 'width: 60%;' : '')}
`;

const Section = (props) => {
  const {
    disableRightPadding,
    id,
    size,
    disableMargin,
    disablePadding,
    style,
    className,
    children
  } = props;
  const rightPadding = disableRightPadding ? ' no-right-padding' : '';
  return (
    <SectionWrapper
      id={id}
      size={size}
      disableMargin={disableMargin}
      disablePadding={disablePadding}
      style={style}
      className={className}
    >
      <div className={`section-container${disablePadding ? ' no-padding' : rightPadding}`}>
        {children}
      </div>
    </SectionWrapper>
  );
};

Section.propTypes = {
  disableMargin: PropTypes.bool,
  disablePadding: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  disableRightPadding: PropTypes.bool,
  size: PropTypes.string,
  style: PropTypes.shape()
};

Section.defaultProps = {
  disableMargin: false,
  disablePadding: false,
  id: null,
  className: null,
  disableRightPadding: false,
  size: 'large',
  style: {}
};

export default Section;
